import { useAvailableReportDates } from "../useAvailableReportDates"

interface UseDataValue {
  dataHasData: boolean
  dataIsFetched: boolean
}

/**
 * Determines if the active organization has the necessary data for the app to display
 *
 * @returns The data status
 */
export const useData = (): UseDataValue => {
  const { availableReportDatesData, availableReportDatesIsFetched } =
    useAvailableReportDates()

  return {
    dataHasData: availableReportDatesData?.isValid ?? false,
    dataIsFetched: availableReportDatesIsFetched,
  }
}
